module.exports = __webpack_public_path__ + "img/bomb.77d2bd33.svg";